import { useCallback, useMemo, useState } from 'react';

import { getCustomActionComponent } from '../constants/customActionRegistry';

/**
 * Tracks which registry modal (if any) should render. This is UI state only —
 * `useComponentAction` is stateless and does not hold an "active modal".
 */
const useCustomActionModalTarget = () => {
  const [targetId, setTargetId] = useState<string | null>(null);

  const clearTarget = useCallback(() => setTargetId(null), []);

  const CustomModal = useMemo(
    () => (targetId ? getCustomActionComponent(targetId) : undefined),
    [targetId]
  );

  return useMemo(
    () => ({
      targetId,
      setTargetId,
      clearTarget,
      CustomModal
    }),
    [targetId, clearTarget, CustomModal]
  );
};

export default useCustomActionModalTarget;
